import { useCallback, useEffect, useState } from 'react';
import useIsomorphicLayoutEffect from './useIsomorphicLayoutEffect';
import { useTheme } from 'styled-components';

/**
 * React Hook that returns the current window size
 * and report updates from the 'resize' window event
 *
 * @typedef {useIsMobile} useIsMobile
 * @property {number} isMobile Window width judgment...
 * @returns {isMobile} A value representing whether the width is less than 768
 */

const useIsMobile = (): boolean => {
    const initialWidth =
        // @ts-ignore // get width from
        (typeof global !== 'undefined' && global.width) ||
        // @ts-ignore
        (typeof window !== 'undefined' && window?.__data?.windowSize?.width) ||
        1024;

    const {
        // @ts-ignore will fix when caterwaul becomes ts
        breakpoints: { tabletNarrowWidthNum },
    } = useTheme();

    const [isMobile, setMobile] = useState(initialWidth < tabletNarrowWidthNum);

    useIsomorphicLayoutEffect(() => {
        setMobile(window.innerWidth < tabletNarrowWidthNum);
    }, []);

    const handleResize = useCallback(() => {
        if (isMobile !== window.innerWidth < tabletNarrowWidthNum) {
            setMobile(window.innerWidth < tabletNarrowWidthNum);
        }
    }, [isMobile, tabletNarrowWidthNum]);

    useEffect(() => {
        // Add event listener for window resize events
        window.addEventListener('resize', handleResize);
        window.addEventListener('orientationchange', handleResize);

        // Remove event listener
        return () => {
            window.removeEventListener('resize', handleResize);
            window.removeEventListener('orientationchange', handleResize);
        };
    });

    return isMobile;
};

export default useIsMobile;
